import React from 'react'
import { Outlet } from 'react-router-dom'
import PageTabs from '../shared/PageTabs.jsx'
import { useEbayRequests } from '../../hooks/useEbayRequests.jsx'
import { useReverbOffers } from '../../hooks/useReverbOffers.jsx'
import { WarningBadge, REVERB_OFFERS_WARNING_TITLE } from '../Layout.jsx'
import '../../styles/pages.css'

const CASES_PATH = '/orders/cases'
const REVERB_OFFERS_PATH = '/orders/reverb-offers'
const EBAY_ALERT_TITLE = 'An eBay request is close to its deadline'

const tabs = [
  { path: '/orders/list', label: 'Orders' },
  { path: CASES_PATH, label: 'Cases' },
  { path: REVERB_OFFERS_PATH, label: 'Reverb Offers' },
  { path: '/orders/returns', label: 'Return Items' },
  { path: '/orders/printruns', label: 'Printruns' }
]

// The Cases tab carries the same red "!" as the menu when an eBay request is
// amber, red or overdue (spec 20261013). Both read one shared view.
export function tabsWithEbayAlert(attentionCount) {
  if (!attentionCount) return tabs
  return tabs.map(tab => tab.path === CASES_PATH
    ? {
      ...tab,
      label: (
        <>
          Cases{' '}
          <span className="nav-alert-badge" style={{ marginLeft: 'var(--space-1)' }} title={EBAY_ALERT_TITLE} aria-label={EBAY_ALERT_TITLE}>!</span>
        </>
      )
    }
    : tab)
}

// The Reverb Offers tab carries the same yellow "!" as the menu while any
// Reverb Buyer Offer waits for our reply (spec 20261015).
export function tabsWithReverbWarning(tabList, awaitingCount) {
  if (!awaitingCount) return tabList
  return tabList.map(tab => tab.path === REVERB_OFFERS_PATH
    ? { ...tab, label: <>Reverb Offers{' '}<WarningBadge title={REVERB_OFFERS_WARNING_TITLE} /></> }
    : tab)
}

function OrdersPage() {
  const { view } = useEbayRequests()
  const { awaitingCount } = useReverbOffers()

  return (
    <div className="page">
      <div className="pageHead">
        <h1>Orders</h1>
        <p>Search and manage orders</p>
      </div>

      <PageTabs
        tabs={tabsWithReverbWarning(tabsWithEbayAlert(view.attention_count), awaitingCount)}
        match="exact"
      />

      <Outlet />
    </div>
  )
}

export default OrdersPage
